export enum LinkedInRefEnum {
  FIRST_NAME = 'firstName',
  SUR_NAME = 'surName',
  EMAIL = 'email',
  LINKED_IN_URL = 'linkedInUrl'
}
